import styled from 'styled-components';

const MessageContainer = styled.article`
	.MuiGrid-container {
		.MuiGrid-item {
			z-index: 1;
		}
	}
	${props => props.theme.breakpoints.up('xs')} {
		padding: 6% 8% 15% 8%;
		h2 {
			margin-left: -2px;
		}
	}
	${props => props.theme.breakpoints.up('sm')} {
		padding: 5% 11% 12% 11%;
		h2 {
			margin-left: -4px;
		}
	}

	.logo {
		${props => props.theme.breakpoints.up('xs')} {
			display: none;
		}
		${props => props.theme.breakpoints.up('sm')} {
			display: block;
		}
		height: 70px;
	}

	p {
		margin: 2% 0px 5% 0px;
	}
`;

export default MessageContainer;
